import { CartItem } from 'types/cart';

export const CART_LOCAL_STORAGE_KEY = 'cart';

export const addCartItemToLocalStorage = (item: CartItem) => {
  const existingCart = getCartFromLocalStorage();
  const updatedCart = {
    lastUpdated: new Date(),
    items: existingCart ? [...existingCart.items, item] : [item],
  };

  localStorage.setItem(CART_LOCAL_STORAGE_KEY, JSON.stringify(updatedCart));
};

export const removeCartItemFromLocalStorage = (itemId: string) => {
  const existingCart = getCartFromLocalStorage();
  if (!existingCart) {
    return;
  }
  const updatedItems = existingCart.items.filter((item) => item.id !== itemId);
  const updatedCart = {
    lastUpdated: new Date(),
    items: updatedItems,
  };
  localStorage.setItem(CART_LOCAL_STORAGE_KEY, JSON.stringify(updatedCart));
}

export const getCartFromLocalStorage = (): { lastUpdated: Date; items: CartItem[] } | null => {
  const cartString = localStorage.getItem(CART_LOCAL_STORAGE_KEY);
  if (!cartString) {
    return null;
  }
  return JSON.parse(cartString);
};

export const clearCartFromLocalStorage = () => {
  localStorage.removeItem(CART_LOCAL_STORAGE_KEY);
};
